import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createFab = ({ palette, typography, shadows }: Theme): Components => ({
  MuiFab: {
    styleOverrides: {
      root: {
        fontSize: typography.pxToRem(15),
        letterSpacing: '0.013em',
        boxShadow: shadows[4],
        '&:active': {
          boxShadow: shadows[4],
        },
      },
      extended: {
        borderRadius: 56 / 2,
        padding: '0 24px',
        width: 'auto',
        minHeight: 'auto',
        minWidth: 56,
        height: 56,
        '& > .MuiFab-label > *:first-child': {
          marginRight: 8,
        },
      },
      secondary: {
        '&:hover': {
          backgroundColor: palette.secondary.darkHover,
          '@media (hover: none)': {
            backgroundColor: palette.secondary.main,
          },
        },
        '&.Mui-disabled': {
          backgroundColor: palette.secondary.main,
          color: palette.secondary.contrastText,
          opacity: 0.38,
        },
      },
    },
  },
});

export default createFab;
